import ServiceLocator from '../../../services/ServiceLocator';
import { AsyncAction } from '../../types';
import { RefreshTokenIfNeeded } from '../../auth/actions';
import { HandleError } from '../../../stores/page/actions';
import { API_APPLICATIONS_LOADED, API_APPLICATION_UPDATED, API_APPLICATION_VERSIONS_LOADED, API_APPLICATION_DEPLOYED, ApplicationActionTypes, API_APPLICATION_REMOVED } from './types';
import ApplicationResponse, { ApplicationData } from '../../../api/dtos/application/ApplicationResponse';
import { ApplicationVersionData } from '../../../api/dtos/application/ApplicationVersionResponse';

export function ApiGetApplications(): AsyncAction {
    return RefreshTokenIfNeeded(async dispatch => {
        const response = await ServiceLocator.ApplicationService.GetApplications();
        if (response.is_success) {
            dispatch(ApplicationsLoaded(response.data));
        }
        else {
            dispatch(HandleError(response));
        }
    });
}

export function ApiGetApplicationVersions(applicationId: number): AsyncAction {
    return RefreshTokenIfNeeded(async dispatch => {
        const response = await ServiceLocator.ApplicationService.GetApplicationVersions(applicationId);
        if (response.is_success) {
            dispatch(ApplicationVersionsLoaded(response.data));
        }
        else {
            dispatch(HandleError(response));
        }
    });
}

export function ApiRemoveApplication(applicationId: number): AsyncAction {
    return RefreshTokenIfNeeded(async dispatch => {
        const response = await ServiceLocator.ApplicationService.RemoveApplication(applicationId);
        if (response.is_success) {
            dispatch(ApplicationRemoved(applicationId));
        }
        else {
            dispatch(HandleError(response));
        }
    });
}

function ApplicationsLoaded(applications: ApplicationData[]): ApplicationActionTypes {
    return {
        type: API_APPLICATIONS_LOADED,
        applications
    };
}

export function ApplicationUpdated(applicationId: number, application: ApplicationResponse): ApplicationActionTypes {
    return {
        type: API_APPLICATION_UPDATED,
        applicationId,
        application
    };
}

function ApplicationVersionsLoaded(versions: ApplicationVersionData[]): ApplicationActionTypes {
    return {
        type: API_APPLICATION_VERSIONS_LOADED,
        versions
    };
}

export function ApplicationDeployed(): ApplicationActionTypes {
    return {
        type: API_APPLICATION_DEPLOYED
    };
}

function ApplicationRemoved(applicationId: number): ApplicationActionTypes {
    return {
        type: API_APPLICATION_REMOVED,
        applicationId
    };
}
